import React from "react";

export function InfoIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 47 47"
      width="30"
      height="30"
      {...props}
    >
      <g id="icons">
        <g id="Info">
          <path
            className="cls-1"
            d="m23.5,47C10.54,47,0,36.46,0,23.5S10.54,0,23.5,0s23.5,10.54,23.5,23.5-10.54,23.5-23.5,23.5Zm0-45C11.65,2,2,11.65,2,23.5s9.65,21.5,21.5,21.5,21.5-9.65,21.5-21.5S35.35,2,23.5,2Z"
          />
          <path
            className="cls-1"
            d="m20.12,31.52c.07-.3.17-.71.31-1.21l1.85-6.77c.02-.08.04-.16.05-.24.01-.08.02-.15.02-.22,0-.4-.13-.65-.38-.75-.25-.1-.72-.16-1.4-.19v-.79c.56-.04,1.39-.12,2.46-.24,1.08-.12,1.84-.23,2.29-.32l1.29-.25-2.34,8.58c-.2.74-.33,1.25-.4,1.53-.18.73-.27,1.2-.27,1.41s.05.36.15.42c.1.06.21.1.32.1.31,0,.68-.26,1.14-.78.45-.52.85-1.07,1.2-1.63l.66.43c-.98,1.44-1.73,2.42-2.26,2.92-.85.82-1.77,1.24-2.74,1.24-.55,0-1.04-.17-1.48-.51-.44-.34-.66-.86-.66-1.55,0-.25.06-.63.18-1.16Zm7.09-17.12c.39.39.59.87.59,1.43s-.2,1.04-.59,1.44c-.39.4-.87.6-1.43.6s-1.04-.2-1.44-.6c-.4-.4-.6-.88-.6-1.44s.2-1.04.6-1.43c.4-.39.88-.59,1.44-.59s1.04.2,1.43.59Z"
          />
        </g>
      </g>
    </svg>
  );
}
